export default function ServiceAreas() {
  const areas = [
    {
      name: 'Eixample',
      icon: 'ri-building-line'
    },
    {
      name: 'Gràcia',
      icon: 'ri-community-line'
    },
    {
      name: 'Sants-Montjuïc',
      icon: 'ri-landscape-line'
    },
    {
      name: 'Les Corts',
      icon: 'ri-home-heart-line'
    },
    {
      name: 'Sarrià-Sant Gervasi',
      icon: 'ri-home-smile-line'
    },
    {
      name: 'Horta-Guinardó',
      icon: 'ri-plant-line'
    },
    {
      name: 'Nou Barris',
      icon: 'ri-home-4-line'
    },
    {
      name: 'Sant Andreu',
      icon: 'ri-building-2-line'
    },
    {
      name: 'Sant Martí',
      icon: 'ri-home-3-line'
    },
    {
      name: 'Ciutat Vella',
      icon: 'ri-ancient-gate-line'
    },
    {
      name: 'Poblenou',
      icon: 'ri-building-4-line'
    },
    {
      name: 'Barceloneta',
      icon: 'ri-ship-line'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-teal-50 to-cyan-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Zonas de servicio en Barcelona
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Ofrecemos nuestro servicio profesional de vaciado de pisos en los principales barrios de Barcelona y área metropolitana. Estamos cerca de ti.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12">
          {areas.map((area, index) => (
            <div
              key={index}
              className="bg-white rounded-lg sm:rounded-xl p-4 sm:p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-teal-600 transition-colors">
                <i className={`${area.icon} text-xl sm:text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-sm sm:text-base font-semibold text-gray-900 group-hover:text-teal-600 transition-colors break-words">
                {area.name}
              </h3>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg">
          <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-map-pin-2-fill text-3xl sm:text-4xl text-white"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 px-2">
                ¿Tu barrio no está en la lista?
              </h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4 px-2">
                También trabajamos en toda el área metropolitana de Barcelona. Contáctanos y te confirmaremos si llegamos a tu zona.
              </p>
              <a
                href="tel:629501941"
                className="inline-flex items-center gap-2 bg-teal-600 text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-lg sm:text-xl"></i>
                Llámanos: 629 501 941
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}